import React from 'react';
import ReactDOM from 'react-dom';
import './assets/scss/style.scss';
import App from './App';
import {Provider} from 'react-redux';
import store from './stores';
import ServiceWorker from './services/service-worker';
import './i18n';
import { appEnv } from './config/env';

ServiceWorker.register();

if ('Notification' in window) {
  Notification.requestPermission();
}

// 外部APIスクリプトを環境変数から読み込む
const externalApiHost = appEnv.webRtcUrl;
if (externalApiHost) {
  const script = document.createElement("script");
  script.src = `${externalApiHost}/external_api.js`;
  script.async = true;
  document.head.appendChild(script);
}

ReactDOM.render(
  <Provider store={store}>
    <React.StrictMode>
      <App/>
    </React.StrictMode>
  </Provider>,
  document.getElementById('root')
);
